import Vue from 'vue';
import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'message';

    loadBackendNotifications(page, limit) {
        return this.get({
            params: {
                limit,
                'response-group': 'org_backend_messages_list',
                page,
                filter: [
                    {
                        field: 'isBackend',
                        value: true,
                        type: 'eq',
                    },
                    {
                        field: 'senderOrganization',
                        value: Vue.$store.state.organization.selectedOrganizationID,
                        type: 'eq',
                    }
                ],
                'order-by': [
                    {
                        field: 'date',
                        direction: 'DESC',
                        type: 'field',
                    },
                ],
            },
        });
    }
}

export const NotificationModel = new model();
